export var breakPoints = {
  xs: 480,
  sm: 768,
  md: 992,
  lg: 1200
};
export var defaultSizes = {
  phone: breakPoints.sm - 1,
  tablet: breakPoints.md - 1,
  desktop: breakPoints.lg
};